const addictions = [
    "Vaping",
    "Marihuana",
    "Otras drogas",
    "Medicamentos",
    "Cafeína",
    "Apuestas",
    "Compras",
    "Ninguna",
  ];
  
  export default addictions;
  